export default "__VITE_ASSET__1ae8eb68__"